import EmailSenderLayout from "../EmailSenderLayout";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { NSBox, NSBoxEmail, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";
import Styles from "./SendPage.module.css"
import { useRef } from "react";
import { ProviderRow } from "namirasoft-email-sender";
import { useParams } from "react-router-dom";
import { EmailSenderRoutes } from "../EmailSenderRoutes";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

export interface ISendPageProps extends NSARouterMakerProps, EmailSenderRouterProps
{ }

function SendPage(props: ISendPageProps)
{
	let NSBoxEmail_Email = useRef<NSBoxEmail>(null);
	let NSBoxString_Title = useRef<NSBoxString>(null);
	let NSBoxTextarea_Message = useRef<NSBoxTextArea>(null);
	let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);

	let { id } = useParams();

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<EmailSenderLayout {...props}
			action={{
				title: "Send",
				description: "Enter the destination email address and your message to send an email via the selected provider.",
				menus: {}
			}}
		>
			<NSPanel>
				<NSColumn style={{ width: NSBox.width.double }}>
					<NSRow>
						<NSBoxEntity<ProviderRow>
							ref={NSBoxEntity_Provider}
							title="Provider"
							required
							multiple={false}
							table={namirasoft.email_sender.tables.provider}
							getValue={item => item.id}
							getTitle={item => item.name}
							getSort={() => null}
							onLoaded={() =>
							{
								if (id)
									NSBoxEntity_Provider.current?.setValue(id);
							}}
						/>
						<NSBoxEmail
							ref={NSBoxEmail_Email}
							title="Email"
							classList={[Styles.send_page_email]}
							required
						/>
					</NSRow>
					<NSBoxString
						ref={NSBoxString_Title}
						title="Title"
						classList={[Styles.send_page_email]}
						required
						style={{ width: "100%" }}
					/>
					<NSBoxTextArea
						ref={NSBoxTextarea_Message}
						title="Message"
						required
						placeholder="Write your Message"
						style={{ width: "100%" }}
					/>
					<NSSpace size={NSSpaceSizeType.MINI}
					></NSSpace>
					<NSRow>
						<NSButtonBlue title="Apply" onClick={{
							action: (onFinshied) =>
							{
								try
								{
									let provider_id = NSBoxEntity_Provider.current?.getValueOne();
									if (provider_id)
									{
										let email = NSBoxEmail_Email.current?.getValue() ?? "";
										let title = NSBoxString_Title.current?.getValue() ?? ""
										let message = NSBoxTextarea_Message.current?.getValue() ?? ""
										props.servers.email_sender.email.Send({ provider_id, email, title, message, html: false }).then((res) =>
										{
											props.notifier.onSuccess("An email was sent successfully");

											let filters = [new FilterItem(namirasoft.email_sender.tables.sent, namirasoft.email_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
											props.url.redirect(EmailSenderRoutes.SentList, { filters: FilterItem.encode(filters) });

											onFinshied();
										}).catch(onFinshied);
									}
									onFinshied();
								} catch (error)
								{
									props.notifier.onError(error as Error);
								}
							}
						}} />
					</NSRow>
				</NSColumn>
			</NSPanel>
		</EmailSenderLayout>
	);
}

export default SendPage;